import React from 'react';
import emailjs from 'emailjs-com';
import Footer from '../Shared/Footer/Footer';
import Navigation from '../Shared/Navigation/Navigation';

const ContactMe = () => {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_xb8qowi', 'template_zdpsw2e', e.target, 'user_QZaaRB9aGTyfKvXJRk5Rl')
        .then((result) => {
            if (result) {
                alert('Your Message Send Successfully')
            }
        }, (error) => {
            console.log(error.text);
        });
    e.target.reset();
}
  return (
    <>
      <Navigation />
      <main id="contact" className='container'>
        <h3 className="text-white" data-aos="fade-right" data-aos-duration="500">Contact Me </h3>
        <div className="container mb-5"  data-aos="fade-up" data-aos-duration="1000">
          <form className="inputedit" onSubmit={sendEmail} name="contactForm" id="contact" >
            <fieldset>
              <input placeholder="Your name" type="text" id="name" name="name" tabIndex="1" required autoFocus />
            </fieldset>
            <fieldset>
              <input placeholder="Your Email Address" type="email" id="email" name="email" tabIndex="2" required />
            </fieldset>
            <fieldset>
              <textarea placeholder="Type your message here...." tabIndex="5" id="message" name="message" required></textarea>
            </fieldset>
            <fieldset>
              <button type="submit" id="contact-submit">Submit</button>
              <p style={{fontStyle: 'italic'}} className="text-white">Sending to - <a href="mailto:shahinur.alam.bhuiyan01@gmail.com"> &nbsp;shahinur.alam.bhuiyan01@gmail.com</a> </p>
            </fieldset>
          </form>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ContactMe;